import { Suspense } from 'react'
import { Link, Outlet } from 'react-router-dom'
import { ROUTES } from '@shared/config/routes'
import { usePageTitle } from '@shared/lib/usePageTitle'
import { LanguageSelector } from '@shared/ui/LanguageSelector/LanguageSelector'
import { Spinner } from '@shared/ui/Spinner'

export function AuthLayout() {
  usePageTitle()
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <header className="mx-auto flex w-full max-w-lg items-center justify-between px-6 py-4">
        <Link to={ROUTES.LOGIN}>
          <img src="/images/logo.png" alt="FEMO" width="107" height="24" className="h-6" />
        </Link>
        <LanguageSelector className="w-24" />
      </header>
      <main className="mx-auto flex w-full max-w-[504px] flex-1 items-center justify-center px-6 py-8">
        <Suspense
          fallback={
            <div className="flex h-64 items-center justify-center">
              <Spinner className="h-20 w-20" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
